import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import {
  GetSeasonalPredictionFilters,
  GetSeasonalPredictionEdit,
  GetSeasonalPredictionTemporal,
  UpdateModifiedDataSeasonal,
  ApplyPredictionPercentagesSeasonal,
  PostGenerateSeasonalPrediction,
  GetGenerationSeasonalPredictionTemporal,
  GetSeasonalPredictionEditSemanaSanta,
  GetEstacionalPrediction,
  PostGenerateSeasonalSemanaSanta,
  SetCurrentFiltersSeasonal,
  SetSelectedSeasonalDate,
  SetActualBaseEstacional,
  SetSelectedTabHome,
} from './estacional-prediction.actions';
import { EstacionalPredictionService } from '../../core/services/estacional-prediction/estacional-prediction.service';
import {
  IGetStandardPredictionResponse,
  IModifiedData,
  IStandardPredictionFilter,
} from '../../core/interfaces/standard-prediction.interface';
import { interval, throwError } from 'rxjs';
import { tap, switchMap, filter, take, catchError } from 'rxjs/operators';
import { IGetFiltersResponse } from '../../core/interfaces/estacional-prediction.interface';
import { IGetEstacionalRequest } from '../../core/interfaces/estacional-prediction.interface';
import {
  LoadingHiddeAction,
  LoadingShowAction,
} from '../loading/loading.actions';

export interface EstacionalPredictionStateModel {
  predictions: IGetStandardPredictionResponse[];
  modifiedData: IModifiedData[];
  error: any;
  currentFilters?: any;
  actualBase: string;
  filters: IGetFiltersResponse[];
  predictionType: string;
  filtersSeasonal: IStandardPredictionFilter | null;
  selectedSeasonalDate: string;
  selectedSeasonalModel: string;
  selectedTabHome: number;
}

@State<EstacionalPredictionStateModel>({
  name: 'estacionalPrediction',
  defaults: {
    predictions: [],
    modifiedData: [
      {
        id: 'udc',
        description: 'Último dato coincidente',
        value: 100,
      },
      {
        id: 'pudc',
        description: 'Promedio de los últimos datos coincidentes',
        value: 0,
      },
      {
        id: 'rcdtac',
        description:
          'Razón de cambio de un día coincidente respecto a un periodo típico anterior',
        value: 0,
      },
      {
        id: 'rcudc',
        description:
          'Razón de cambio respecto a los últimos datos coincidentes',
        value: 0,
      },
    ],
    error: null,
    actualBase: '3',
    filters: [],
    predictionType: '',
    filtersSeasonal: null,
    selectedSeasonalDate: '',
    selectedSeasonalModel: '',
    selectedTabHome: 0,
  },
})
@Injectable()
export class EstacionalPredictionState {
  constructor(private seasonalPredictionService: EstacionalPredictionService) {}

  @Selector()
  static getPredictions(state: EstacionalPredictionStateModel) {
    return state.predictions;
  }

  @Selector()
  static getError(state: EstacionalPredictionStateModel) {
    return state.error;
  }

  @Selector()
  static getModifiedData(state: EstacionalPredictionStateModel) {
    return state.modifiedData;
  }

  @Selector()
  static getActualBase(state: EstacionalPredictionStateModel) {
    return state.actualBase;
  }

  @Selector()
  static getFiltersEstacional(state: EstacionalPredictionStateModel) {
    return state.filters;
  }

  @Selector()
  static getFiltersSeasonal(state: EstacionalPredictionStateModel) {
    return state.filtersSeasonal;
  }

  @Selector()
  static getSelectedSeasonalDate(state: EstacionalPredictionStateModel) {
    return state.selectedSeasonalDate;
  }

  @Selector()
  static getSelectedSeasonalModel(state: EstacionalPredictionStateModel) {
    return state.selectedSeasonalModel;
  }

  @Selector()
  static getSelectedTabHome(state: EstacionalPredictionStateModel) {
    return state.selectedTabHome;
  }

  @Selector()
  static getCurrentFilters(state: EstacionalPredictionStateModel) {
    return state.currentFilters;
  }

  @Action(GetSeasonalPredictionFilters)
  getSeasonalPredictionFilters(
    ctx: StateContext<EstacionalPredictionStateModel>
  ) {
    return this.seasonalPredictionService.getSeasonalPredictionFilters().pipe(
      tap({
        next: response => {
          ctx.patchState({
            filters: response,
          });
        },
        error: error => {
          ctx.patchState({
            error,
          });
        },
      })
    );
  }

  @Action(GetSeasonalPredictionEdit)
  getSeasonalPredictionEdit(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: GetSeasonalPredictionEdit
  ) {
    setTimeout(() => {
      ctx.dispatch(new LoadingShowAction());
    }, 1000);

    return this.seasonalPredictionService
      .getSeasonalPredictionEdit(action.payload, action.predictionType)
      .pipe(
        tap({
          next: response => {
            ctx.dispatch(new GetSeasonalPredictionTemporal(response.uuid));
          },
          error: error => {
            ctx.dispatch(new LoadingHiddeAction());
          },
        })
      );
  }

  @Action(GetSeasonalPredictionEditSemanaSanta)
  getSeasonalPredictionEditSemanaSanta(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: GetSeasonalPredictionEditSemanaSanta
  ) {
    setTimeout(() => {
      ctx.dispatch(new LoadingShowAction());
    }, 1000);
    return this.seasonalPredictionService
      .getSeasonalPredictionEditSemanaSanta(action.payload)
      .pipe(
        tap({
          next: response => {
            ctx.dispatch(new GetSeasonalPredictionTemporal(response.uuid));
          },
          error: error => {
            ctx.dispatch(new LoadingHiddeAction());
          },
        })
      );
  }

  @Action(GetSeasonalPredictionTemporal)
  getSeasonalPredictionTemporal(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: GetSeasonalPredictionTemporal
  ) {
    ctx.dispatch(new LoadingShowAction());

    return interval(5000).pipe(
      switchMap(() =>
        this.seasonalPredictionService
          .getSeasonalPredictionTemporal(action.payload)
          .pipe(
            catchError(error => {
              ctx.dispatch(new LoadingHiddeAction());
              return throwError(() => error);
            })
          )
      ),
      filter(
        response => !!response && Array.isArray(response) && response.length > 0
      ), // solo si hay datos
      take(1),
      tap({
        next: response => {
          ctx.patchState({
            predictions: response as IGetStandardPredictionResponse[],
          });
          ctx.dispatch(new LoadingHiddeAction());
        },
        error: error => {
          ctx.dispatch(new LoadingHiddeAction());
        },
      })
    );
  }

  @Action(GetEstacionalPrediction)
  getEstacionalPrediction(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: GetEstacionalPrediction
  ) {
    // console.log('🔍 GetEstacionalPrediction - payload recibido:', action.payload);
    return this.seasonalPredictionService
      .getEstacionalPrediction(action.payload)
      .pipe(
        tap({
          next: response => {
            // ✅ Preservar los filtros del request para futuras consultas
            const state = ctx.getState();
            // console.log('📊 GetEstacionalPrediction - currentFilters antes:', state.currentFilters);
            const shouldUpdateFilters =
              !state.currentFilters ||
              Object.keys(state.currentFilters?.filters || {}).length === 0;
            // console.log('🤔 GetEstacionalPrediction - ¿Debería actualizar filtros?', shouldUpdateFilters);

            ctx.patchState({
              predictions: response,
              // Solo actualizar currentFilters si no existe o si es diferente
              ...(shouldUpdateFilters
                ? {
                    currentFilters: action.payload,
                  }
                : {}),
            });

            // console.log('✅ GetEstacionalPrediction - currentFilters después:', ctx.getState().currentFilters);
          },
          error: error => {
            ctx.patchState({ error });
          },
        })
      );
  }

  @Action(GetGenerationSeasonalPredictionTemporal)
  GetGenerationSeasonalPredictionTemporal(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: GetGenerationSeasonalPredictionTemporal
  ) {
    // console.log('⏱️ GetGenerationSeasonalPredictionTemporal - iniciando con uuid:', action.payload);
    ctx.dispatch(new LoadingShowAction());

    return interval(2000).pipe(
      switchMap(() =>
        this.seasonalPredictionService
          .getSeasonalPredictionTemporal(action.payload)
          .pipe(
            catchError(error => {
              ctx.dispatch(new LoadingHiddeAction());
              return throwError(() => error);
            })
          )
      ),
      filter((response: any) => {
        if (response?.status === 200) {
          return true;
        }
        if (Array.isArray(response) && response.length === 0) {
          return false;
        }
        const shouldContinue = Array.isArray(response) && response.length > 0;
        return shouldContinue;
      }),
      take(1),
      tap({
        next: (response: any) => {
          if (response?.status === 200) {
            const state = ctx.getState();

            // ✅ Preservar TODOS los filtros del currentFilters original
            const preservedFilters = {
              ...state.currentFilters?.filters,
              // Asegurar que no se pierdan filtros importantes
              ...(state.currentFilters?.idMedidor
                ? { idMedidor: state.currentFilters.idMedidor }
                : {}),
              ...(state.currentFilters?.puntoSalida
                ? { puntoSalida: state.currentFilters.puntoSalida }
                : {}),
              ...(state.currentFilters?.mercadoVanti
                ? { mercadoVanti: state.currentFilters.mercadoVanti }
                : {}),
              ...(state.currentFilters?.sociedadCom
                ? { sociedadCom: state.currentFilters.sociedadCom }
                : {}),
              ...(state.currentFilters?.sociedadDis
                ? { sociedadDis: state.currentFilters.sociedadDis }
                : {}),
            };

            const request: IGetEstacionalRequest = {
              etiquetaUuid:
                state.currentFilters?.etiquetaUuid ||
                (state.currentFilters?.periodo
                  ? state.filters?.find(
                      f => f.año === state.currentFilters?.periodo
                    )?.uuid || ''
                  : ''),
              filters: preservedFilters, // ✅ Usar filtros preservados
              fechaInicio:
                state.currentFilters?.fechaInicio ||
                state.filters?.find(
                  f => f.año === state.currentFilters?.periodo
                )?.fechaInicio ||
                '',
              fechaFin:
                state.currentFilters?.fechaFin ||
                state.filters?.find(
                  f => f.año === state.currentFilters?.periodo
                )?.fechaFin ||
                '',
            };

            // console.log(
            //   "🔍 GetEstacionalPrediction request con filtros preservados:",
            //   request
            // );
            ctx.dispatch(new GetEstacionalPrediction(request));
            ctx.dispatch(new LoadingHiddeAction());
          } else if (Array.isArray(response)) {
            ctx.patchState({
              predictions: response as IGetStandardPredictionResponse[],
            });
            ctx.dispatch(new LoadingHiddeAction());
          }
        },
        error: error => {
          ctx.dispatch(new LoadingHiddeAction());
        },
      })
    );
  }

  @Action(PostGenerateSeasonalPrediction)
  postGenerateSeasonalPrediction(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: PostGenerateSeasonalPrediction
  ) {
    // console.log('🚀 PostGenerateSeasonalPrediction - action.payload:', action.payload);
    ctx.dispatch(new LoadingShowAction());
    return this.seasonalPredictionService
      .postGenerateSeasonalPrediction(action.payload, action.predictionType)
      .pipe(
        tap({
          next: response => {
            if (response && response.uuid) {
              const state = ctx.getState();
              // console.log('📊 PostGenerateSeasonalPrediction - currentFilters antes:', state.currentFilters);
              // ✅ Preservar etiquetaUuid del currentFilters anterior si existe
              const preservedEtiquetaUuid = state.currentFilters?.etiquetaUuid;
              const newCurrentFilters = {
                ...action.payload,
                ...(preservedEtiquetaUuid
                  ? { etiquetaUuid: preservedEtiquetaUuid }
                  : {}),
              };
              // console.log('💾 PostGenerateSeasonalPrediction - guardando currentFilters:', newCurrentFilters);
              ctx.patchState({
                currentFilters: newCurrentFilters,
                predictionType: action.predictionType,
              });
              ctx.dispatch(
                new GetGenerationSeasonalPredictionTemporal(response.uuid)
              );
            }
          },
          error: error => {
            ctx.dispatch(new LoadingHiddeAction());
          },
        })
      );
  }

  @Action(PostGenerateSeasonalSemanaSanta)
  PostGenerateSeasonalSemanaSanta(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: PostGenerateSeasonalSemanaSanta
  ) {
    ctx.dispatch(new LoadingShowAction());
    return this.seasonalPredictionService
      .postGenerateSeasonalPrediction(action.payload, action.predictionType)
      .pipe(
        tap({
          next: response => {
            if (response && response.uuid) {
              const state = ctx.getState();
              // ✅ Preservar etiquetaUuid del currentFilters anterior si existe
              const preservedEtiquetaUuid = state.currentFilters?.etiquetaUuid;
              ctx.patchState({
                currentFilters: {
                  ...action.payload,
                  ...(preservedEtiquetaUuid
                    ? { etiquetaUuid: preservedEtiquetaUuid }
                    : {}),
                },
                predictionType: action.predictionType,
              });
              ctx.dispatch(
                new GetGenerationSeasonalPredictionTemporal(response.uuid)
              );
            }
          },
          error: error => {
            ctx.dispatch(new LoadingHiddeAction());
          },
        })
      );
  }

  @Action(UpdateModifiedDataSeasonal)
  UpdateModifiedDataSeasonal(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: UpdateModifiedDataSeasonal
  ) {
    const state = ctx.getState();
    const updated = action.payload;
    let modifiedData = state.modifiedData.map(item =>
      item.id === updated.id ? { ...item, value: updated.value } : item
    );

    const total = modifiedData.reduce(
      (sum, item) => sum + Number(item.value),
      0
    );

    if (total > 100) {
      const diff = total - 100;
      for (let i = 0; i < modifiedData.length; i++) {
        if (modifiedData[i].id !== updated.id) {
          modifiedData[i] = {
            ...modifiedData[i],
            value: Math.max(0, modifiedData[i].value - diff),
          };
          break;
        }
      }
    }

    ctx.patchState({ modifiedData });
  }

  @Action(ApplyPredictionPercentagesSeasonal)
  applyPredictionPercentagesSeasonal(
    ctx: StateContext<EstacionalPredictionStateModel>
  ) {
    const state = ctx.getState();
    const percentages = state.modifiedData.reduce(
      (acc, item) => {
        acc[item.id] = Number(item.value) / 100;
        return acc;
      },
      {} as Record<string, number>
    );

    const predictions = state.predictions.map(row => ({
      ...row,
      mpp: Math.round(
        (row.udc || 0) * (percentages['udc'] || 0) +
          (row.pudc || 0) * (percentages['pudc'] || 0) +
          (row.rcdtac || 0) * (percentages['rcdtac'] || 0) +
          (row.rcudc || 0) * (percentages['rcudc'] || 0)
      ),
    }));

    ctx.patchState({ predictions });
  }

  @Action(SetCurrentFiltersSeasonal)
  setCurrentFiltersSeasonal(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: SetCurrentFiltersSeasonal
  ) {
    // console.log('🔧 SetCurrentFiltersSeasonal - payload:', action.payload);
    ctx.patchState({
      currentFilters: action.payload,
      filtersSeasonal: action.payload,
    });
  }

  @Action(SetSelectedSeasonalDate)
  setSelectedSeasonalDate(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: SetSelectedSeasonalDate
  ) {
    ctx.patchState({ selectedSeasonalDate: action.payload });
  }

  @Action(SetActualBaseEstacional)
  SetActualBaseEstacional(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: SetActualBaseEstacional
  ) {
    ctx.patchState({ actualBase: action.payload });
  }

  @Action(SetSelectedTabHome)
  setSelectedTabHome(
    ctx: StateContext<EstacionalPredictionStateModel>,
    action: SetSelectedTabHome
  ) {
    ctx.patchState({ selectedTabHome: action.payload });
  }
}
